import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";


import { useEffect } from "react";
import socket from "./services/socket";
import { Toaster } from "react-hot-toast";

import AdminLogin from "./admin/pages/Login";
import AdminDashboard from "./admin/pages/Dashboard";
import AdminLayout from "./admin/layouts/AdminLayout";
import AdminProtectedRoute from "./admin/routes/AdminProtectedRoute";
import Categories from "./admin/Categories/Categories";
import AddCategory from "./admin/Categories/AddCategory";
import EditCategory from "./admin/Categories/EditCategory";
import Products from "./admin/Products/Products";
import AddProduct from "./admin/Products/AddProduct";
import EditProduct from "./admin/Products/EditProduct";
import Customers from "./admin/Customers/Customers";
import AddCustomer from "./admin/Customers/AddCustomer";
import EditCustomer from "./admin/Customers/EditCustomer";
import Suppliers from "./admin/Suppliers/Suppliers";
import AddSupplier from "./admin/Suppliers/AddSupplier";
import EditSupplier from "./admin/Suppliers/EditSupplier";
import Purchases from "./admin/Purchases/Purchases";
import AddPurchase from "./admin/Purchases/AddPurchase";
import ViewPurchase from "./admin/Purchases/ViewPurchase";
import Invoices from "./admin/Invoices/Invoices";
import InvoiceForm from "./admin/Invoices/InvoiceForm";
import ViewInvoice from "./admin/Invoices/ViewInvoice";
import StockReport from "./admin/pages/StockReport";
import SalesReport from "./admin/pages/SalesReport";
import Expenses from "./admin/Expenses/Expenses";
import AddExpense from "./admin/Expenses/AddExpense";
import EditExpense from "./admin/Expenses/EditExpense";
import ProfitLoss from "./admin/pages/ProfitLoss";
import Settings from "./admin/pages/Settings";
import LowStock from "./admin/pages/LowStock";
import AdminChangePassword from "./admin/pages/AdminChangePassword";
import AdminProfile from "./admin/pages/AdminProfile";
import Businesses from "./admin/Business/Businesses";
import AddBusiness from "./admin/Business/AddBusiness";
import EditBusiness from "./admin/Business/EditBusiness";
import ViewBusiness from "./admin/Business/ViewBusiness";
import Wallets from "./admin/Wallet/Wallets";
import AddMoney from "./admin/Wallet/AddMoney";
import TransferMoney from "./admin/Wallet/TransferMoney";
import WalletHistory from "./admin/Wallet/WalletHistory";
import SalesReturns from "./admin/SalesReturn/SalesReturns";
import AddSalesReturn from "./admin/SalesReturn/AddSalesReturn";
import ViewSalesReturn from "./admin/SalesReturn/ViewSalesReturn";
import PurchaseReturns from "./admin/PurchaseReturn/PurchaseReturns";
import AddPurchaseReturn from "./admin/PurchaseReturn/AddPurchaseReturn";
import ViewPurchaseReturn from "./admin/PurchaseReturn/ViewPurchaseReturn";
import RolePermissions from "./admin/Roles/RolePermissions";
import Roles from "./admin/Roles/Roles";
import AddRole from "./admin/Roles/AddRole";
import EditRole from "./admin/Roles/EditRole";
import UserDetails from "./admin/pages/UserDetails";
import Users from "./admin/pages/Users";
import AddUser from "./admin/pages/AddUser";
import EditUser from "./admin/pages/EditUser";
import Permissions from "./admin/Permissions/Permissions";
import AddPermission from "./admin/Permissions/AddPermission";
import EditPermission from "./admin/Permissions/EditPermission";
import PermissionRoute from "./admin/routes/PermissionRoute";
import ReceivePayment from "./admin/Invoices/ReceivePayment";
import ReceivePurchasePayment from "./admin/Purchases/ReceivePurchasePayment";
import Partners from "./admin/Partners/Partners";
import AddPartner from "./admin/Partners/AddPartner";
import EditPartner from "./admin/Partners/EditPartner";
import PartnerDetails from "./admin/Partners/PartnerDetails";
import CustomerProfile from "./admin/Customers/CustomerProfile";


function App() {

  useEffect(() => {

    const user =
      JSON.parse(
        localStorage.getItem("user") || localStorage.getItem("admin")
      );

    socket.on("connect", () => {

      if (user?.id) {

        socket.emit(
          "join",
          user.id
        );

        console.log(
          "Joined:",
          user.id
        );
      }
    });

    return () => {
      socket.off("connect");
    };

  }, []);

  return (

    <BrowserRouter>

      <Toaster
        position="top-right"
        reverseOrder={false}
      />
      <Routes>

        {/* // Admin Start here */}
        <Route
          path="/"
          element={<AdminLogin />}
        />

        <Route
          path="/login"
          element={<AdminLogin />}
        />

        <Route
          path="/admin/login"
          element={<AdminLogin />}
        />

        <Route
          path="/admin"
          element={
            <AdminProtectedRoute>
              <AdminLayout />
            </AdminProtectedRoute>
          }
        >

          <Route
            path="dashboard"
            element={
              <PermissionRoute permission="dashboard.view">
                <AdminDashboard />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/categories"
            element={
              <PermissionRoute permission="category.view">
                <Categories />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/categories/add"
            element={
              <PermissionRoute permission="category.add">
                <AddCategory />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/categories/edit/:id"
            element={
              <PermissionRoute permission="category.edit">
                <EditCategory />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/products"
            element={
              <PermissionRoute permission="product.view">
                <Products />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/products/add"
            element={
              <PermissionRoute permission="product.add">
                <AddProduct />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/products/edit/:id"
            element={
              <PermissionRoute permission="product.edit">
                <EditProduct />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/customers"
            element={
              <PermissionRoute permission="customer.view">
                <Customers />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/customers/add"
            element={
              <PermissionRoute permission="customer.add">
                <AddCustomer />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/customers/edit/:id"
            element={
              <PermissionRoute permission="customer.edit">
                <EditCustomer />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/customers/:id"
            element={
              <PermissionRoute permission="customer.edit">
                <CustomerProfile/>
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/suppliers"
            element={
              <PermissionRoute permission="supplier.view">
                <Suppliers />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/suppliers/add"
            element={
              <PermissionRoute permission="supplier.add">
                <AddSupplier />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/suppliers/edit/:id"
            element={
              <PermissionRoute permission="supplier.edit">
                <EditSupplier />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/purchases"
            element={
              <PermissionRoute permission="purchase.view">
                <Purchases />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/purchases/receive-payment"
            element={
              <PermissionRoute permission="purchase.view">
                <ReceivePurchasePayment />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/purchases/add"
            element={
              <PermissionRoute permission="purchase.add">
                <AddPurchase />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/purchases/:id"
            element={
              <PermissionRoute permission="purchase.view">
                <ViewPurchase />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/invoices"
            element={
              <PermissionRoute permission="invoice.view">
                <Invoices />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/invoices/create"
            element={
              <PermissionRoute permission="invoice.add">
                <InvoiceForm />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/invoices/payment/:id"
            element={
              <PermissionRoute permission="invoice.add">
                <ReceivePayment />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/invoices/view/:id"
            element={
              <PermissionRoute permission="invoice.view">
                <ViewInvoice />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/invoices/edit/:id"
            element={
              <PermissionRoute permission="invoice.edit">
                <InvoiceForm />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/stock-report"
            element={
              <PermissionRoute permission="stock_report.view">
                <StockReport />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/sales-report"
            element={
              <PermissionRoute permission="sales_report.view">
                <SalesReport />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/profit-loss"
            element={
              <PermissionRoute permission="profit_loss.view">
                <ProfitLoss />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/low-stock"
            element={
              <PermissionRoute permission="low_stock.view">
                <LowStock />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/expenses"
            element={
              <PermissionRoute permission="expense.view">
                <Expenses />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/expenses/add"
            element={
              <PermissionRoute permission="expense.add">
                <AddExpense />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/expenses/edit/:id"
            element={
              <PermissionRoute permission="expense.edit">
                <EditExpense />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/businesses"
            element={
              <PermissionRoute permission="business.view">
                <Businesses />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/businesses/add"
            element={
              <PermissionRoute permission="business.add">
                <AddBusiness />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/businesses/edit/:id"
            element={
              <PermissionRoute permission="business.edit">
                <EditBusiness />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/businesses/view/:id"
            element={
              <PermissionRoute permission="business.view">
                <ViewBusiness />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/wallets"
            element={
              <PermissionRoute permission="wallet.view">
                <Wallets />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/wallets/add-money"
            element={
              <PermissionRoute permission="wallet.add">
                <AddMoney />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/wallets/withdraw"
            element={
              <PermissionRoute permission="wallet.withdraw">
                <AddMoney />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/wallets/transfer"
            element={
              <PermissionRoute permission="wallet.transfer">
                <TransferMoney />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/wallets/history/:id"
            element={
              <PermissionRoute permission="wallet.transaction">
                <WalletHistory />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/sales-returns"
            element={
              <PermissionRoute permission="sales_return.view">
                <SalesReturns />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/sales-returns/add"
            element={
              <PermissionRoute permission="sales_return.add">
                <AddSalesReturn />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/sales-returns/view/:id"
            element={
              <PermissionRoute permission="sales_return.view">
                <ViewSalesReturn />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/purchase-returns"
            element={
              <PermissionRoute permission="purchase_return.view">
                <PurchaseReturns />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/purchase-returns/add"
            element={
              <PermissionRoute permission="purchase_return.add">
                <AddPurchaseReturn />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/purchase-returns/view/:id"
            element={
              <PermissionRoute permission="purchase_return.view">
                <ViewPurchaseReturn />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/roles"
            element={
              <PermissionRoute permission="role.view">
                <Roles />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/roles/add"
            element={
              <PermissionRoute permission="role.add">
                <AddRole />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/roles/edit/:id"
            element={
              <PermissionRoute permission="role.edit">
                <EditRole />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/roles/permissions/:roleId"
            element={
              <PermissionRoute permission="role.permission">
                <RolePermissions />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/users"
            element={
              <PermissionRoute permission="user.view">
                <Users />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/users/add"
            element={
              <PermissionRoute permission="user.add">
                <AddUser />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/users/edit/:id"
            element={
              <PermissionRoute permission="user.edit">
                <EditUser />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/users/:id"
            element={
              <PermissionRoute permission="user.view">
                <UserDetails />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/partners"
            element={
              <PermissionRoute permission="partner.view">
                <Partners />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/partner/add"
            element={
              <PermissionRoute permission="partner.add">
                <AddPartner />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/partner/edit/:id"
            element={
              <PermissionRoute permission="partner.edit">
                <EditPartner />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/partner/:id"
            element={
              <PermissionRoute permission="partner.view">
                <PartnerDetails />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/permissions"
            element={
              <PermissionRoute permission="permission.view">
                <Permissions />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/permissions/add"
            element={
              <PermissionRoute permission="permission.add">
                <AddPermission />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/permissions/edit/:id"
            element={
              <PermissionRoute permission="permission.edit">
                <EditPermission />
              </PermissionRoute>
            }
          />

          <Route
            path="profile"
            element={
              <PermissionRoute permission="profile.view">
                <AdminProfile />
              </PermissionRoute>
            }
          />

          <Route
            path="change-password"
            element={
              <PermissionRoute permission="password.change">
                <AdminChangePassword />
              </PermissionRoute>
            }
          />

          <Route
            path="/admin/settings"
            element={
              <PermissionRoute permission="setting.view">
                <Settings />
              </PermissionRoute>
            }
          />

        </Route>

      </Routes>

    </BrowserRouter>
  );
}

export default App;